import { Stack, Typography } from "@mui/material";
import { useContext } from "react";
import Image from "src/components/Image";
import useLocales from "src/hooks/useLocales";

import CustomReturnBtn from "../../DynamicForm/components/DConnectBtn/CustomReturnBtn";
import Context from "../context";

// ----------------------------------------------------------------------

const ErrorMessage = () => {
	const { state, theme } = useContext(Context);
	const { translate } = useLocales();

	const getErrorTitle = () => {
		if (state.errorMessage) return translate(`link.${state.errorMessage}`);
		return state.isNotContracted ? "link.error_product" : "link.error_title";
	};

	const getErrorDescription = () => {
		if (state.errorMessage) return translate(`link.${state.errorMessage}_des`);
		return state.isNotContracted ? "link.error_product_des" : "link.error_description";
	};

	return (
		<Stack sx={{ alignItems: "center", minHeight: 415 }}>
			<Image src='/ilustrations/error-amico.svg' />

			<Typography
				variant='subtitle1'
				color={theme?.colors.primaryText}
				sx={{ mt: 2, maxWidth: 320, textAlign: "center" }}
			>
				{translate(getErrorTitle())}
			</Typography>

			<Typography
				variant='body2'
				color={theme?.colors.secondaryText}
				sx={{ mt: 1, maxWidth: 320 }}
				textAlign={"center"}
			>
				{translate(getErrorDescription())}
			</Typography>

			<CustomReturnBtn />
		</Stack>
	);
};

export default ErrorMessage;
